import React from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import crumbs404 from '../assets/page_not_found.svg';

const PageNotFound = () => {
    return (
        <div className="flex flex-col min-h-screen bg-gray-50">
            <NavBar />
            <main className="flex-grow flex flex-col items-center justify-center text-center px-4">
                <img
                    src={crumbs404}
                    alt="Illustration: magnifying glass with 404"
                    className="w-[380px] max-w-full mb-2"
                />
                <h1 className="text-2xl font-semibold mb-2">Page Not Found</h1>
                <p className="text-gray-600 mb-6 max-w-md">
                    Oops! The page you’re looking for doesn’t exist or may have been moved.
                </p>
                <Link
                    to="/"
                    className="px-6 py-3 bg-crumbblue text-white rounded-lg hover:bg-crumborange transition font-medium"
                >
                    Go Back Home
                </Link>
            </main>
            <Footer />
        </div>
    );
};


export default PageNotFound;